import { Link } from "react-router-dom";

const ErrorFallback = ({error,resetErrorBoundary}) => {
    return (
        <div className="container-fluid">

            <div className="text-center">
                <div className="row">
                    <div className="col-md-4 offset-md-4">
                        <img className="m-b-50 img-fluid" src="/assets/staticimages/error-500.png" alt="" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <h2 className="font-weight-800 m-b-20">این صفحه یافت نشد</h2>
                        <Link to="/" className="btn btn-primary">بازگشت به سایت</Link>
                        {/* <pre>{error.message}</pre> */}
                    </div>
                </div>
            </div>

        </div>
    );

}

export default ErrorFallback;